import { Component, EventEmitter, Input, Output } from '@angular/core'
import { BdcPhotoTag } from '@tokeet-frontend/channel-content'
import { BDCPhotoGridCardItem } from './photo-card.interface'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'
import { BdcContentV2Service } from '@tokeet-frontend/channel-content'
import { Store } from '@ngrx/store'
import { Toaster } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-photo-card',
  templateUrl: './photo-card.component.html',
  styleUrls: ['./photo-card.component.scss'],
})
export class PhotoCardComponent {
  @Input() photo: BDCPhotoGridCardItem
  @Input() propertyId: number
  @Input() isSelected = false
  @Input() showSelection = true
  @Input() showDelete = true
  @Input() showSetMain = false
  @Input() showTags = true
  @Input() availableTags: BdcPhotoTag[] = []

  @Output() select = new EventEmitter<string>()
  @Output() delete = new EventEmitter<string>()
  @Output() setMain = new EventEmitter<string>()

  constructor(private contentService: BdcContentV2Service, private store: Store<any>, private toaster: Toaster) {}

  onSelect(): void {
    this.select.emit(this.photo.photo_id)
  }

  onDelete(): void {
    this.delete.emit(this.photo.photo_id)
  }

  onSetMain(): void {
    this.setMain.emit(this.photo.photo_id)
  }

  onTagsChange(tagIds: number[]): void {
    this.contentService.addPhotoTags(this.propertyId, this.photo.photo_id, tagIds).subscribe(
      () => {
        this.toaster.success($localize`Tags updated successfully`)
        this.photo.tag_ids = tagIds
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }
}
